// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2YJVG","option":"styles_option__1egAN","selected":"styles_selected__1Pyf8"};